// import React from "react";
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import MakeAppoinment from '../components/make-appoinment';
import Filter from "../components/Marketfilter";
import useGaspAnimations from '../components/useGsapAnimations'

function MarketBeverage() {

     useGaspAnimations()
     
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
                {/* <section className="breadcrumb-area">
                    <div className="container text-center">
                        <h1>Heat Pumps</h1>
                    </div>
                </section> */}
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li><a href="services.html">Market</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">Beverage</li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start service single area--> */}
                <section id="service-single-area">
                    <div className="container">
                        <div className="row">
                           <Filter/>       
                            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                                <div className="service-single-content">
                                    {/* <!--Start top content --> */}
                                    <div className="row top-content">
                                        <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="img-holder wow zoomInStable animated">
                                                  {/* <Slider {...settings}>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                  </Slider> */}
                                              <img src="assets/images/Market-Images/04.webp" alt="Awesome Image"/>
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12 col-xs-12">
                                            <div className="textholder">
                                                <div className="sec-title bdFadeUp">
                                                    <h1><span>Beverage Industry</span></h1>
                                                </div>
                                                <div className="text bdFadeUp">
                                                    <span>Reliable Cooling & Process Refrigeration for Beverage Manufacturing</span>
                                                    <p className="top">
                                                      Indus Refrigeration provides cutting-edge refrigeration and chilling solutions for the beverage industry, supporting the production, processing, and preservation of a wide range of beverages—from carbonated soft drinks and fruit juices to bottled water, beer, and dairy-based drinks. With a deep understanding of process cooling and hygiene standards, Indus ensures consistent temperature control and uninterrupted operations for beverage manufacturers.
                                                    </p>
                                                    <p>
                                                     Our refrigeration systems are designed to meet the high throughput and precision demands of beverage bottling plants, breweries, distilleries, and juice processing units. Whether it’s cooling product batches, maintaining fermentation temperatures, or storing finished goods in cold rooms, Indus delivers solutions that improve process efficiency and product quality.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--End top content --> */}
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <div className="border"></div>
                                        </div>
                                    </div> */}
                                     <div className="row">
                                        <div className="col-md-12">
                                            <div className="project-description">
                                                <div className="sec-title bdFadeUp">
                                                    <h2>Key Offerings for the Beverage Sector:</h2>
                                                </div>
                                                    <p>Brine and glycol-based chillers for rapid process cooling</p>

                                                    <p>Fermentation room cooling and tank jacket chillers for breweries and distilleries</p>

                                                    <p>Cold storage rooms for packaged beverages and raw ingredients</p>

                                                    <p>Packaged and centralized chilling plants for bottling lines</p>

                                                    <p>Energy-efficient refrigeration systems using ammonia or Freon</p>

                                                    <p>End-to-end project execution including automation, remote monitoring, and maintenance</p>

                                                    <p>Built to withstand 24/7 production demands and seasonal volume spikes, Indus Refrigeration systems help beverage companies reduce energy costs, improve product shelf life, and comply with FSSAI, HACCP, and international food safety regulations.</p>

                                               </div>    
                                        </div>
                                    </div>
                                 
                              
                                </div>
                            </div>  
                        </div>
                    </div>    
                </section>
                {/* <!--End service single area--> */}
                 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default MarketBeverage;


